import { useEffect, useState } from 'react';

import { supabase } from '@/lib/supabase';

import type { Session, User } from '@supabase/supabase-js';

export interface UseSessionResult {
  readonly session: Session | null;
  readonly user: User | null;
  readonly loading: boolean;
  readonly signOut: () => Promise<void>;
}

export function useSession(): UseSessionResult {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    // Initial fetch — el SDK lee la sesión del storage si existe.
    supabase.auth.getSession().then(({ data }) => {
      if (!mounted) return;
      setSession(data.session);
      setLoading(false);
    });

    // Subscribe a cambios. Cubre login, logout, refresh de token.
    const { data } = supabase.auth.onAuthStateChange((_event, nextSession) => {
      if (!mounted) return;
      setSession(nextSession);
      setLoading(false);
    });

    return () => {
      mounted = false;
      data.subscription.unsubscribe();
    };
  }, []);

  return {
    session,
    user: session?.user ?? null,
    loading,
    signOut: async () => {
      await supabase.auth.signOut();
    },
  };
}
